
let transliterations = null;
import('transliterations').then((t) => {
  transliterations = t;
});

const slugify = value => (transliterations ? transliterations.slugify(value) : value);

export default slugify;
